/**
 * @typedef BuyConfigSave 매수 설정 저장 객체 타입
 * @property {string} symbol  거래할 코인 명 (format : [coinName]USDT)
 * @property {string} positionSide  거래할 포지션 (LONG | SHORT)
 * @property {number} initAmt 포지션 진입 자산
 * @property {number} addBuyLimit 추가 매수 횟수 제한 (물타기 제한 횟수)
 * @property {number} buyTriggerPercent  추가 매수 기준
 * @property {number} buyUsdtPercent  추가 매수 진입 자산 비율
 * @property {number} buyStopPercent  추가 매수 중지
 * @property {number} buyUsdtOverLimit  포지션 진입 자산 상한
 * @property {number} retryBuyUsdtOverLimit  포지션 반복 진입 자산 상한
 * @property {number} takeProfitPercent  목표 수익 (수익 실현)
 * @property {number} forceCellPercent  강제 매도
 */

import { authFetch } from "@/plugins/axiosConfig";

/**
 *
 */
const apiPrefix = "/api/order";
export default {
  namespaced: true,
  state: {
    BTCUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
    ETHUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
    XRPUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
    SOLUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
    ADAUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
    DOGEUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
    BNBUSDT: {
      LONG: { config: null, list: [], profit: {}, force: {} },
      SHORT: { config: null, list: [], profit: {}, force: {} },
    },
  },
  getters: {
    GT_LONG_BUY_CONFIGS: (state) => {
      return {
        BTCUSDT: state.BTCUSDT.LONG,
        ETHUSDT: state.ETHUSDT.LONG,
        XRPUSDT: state.XRPUSDT.LONG,
        SOLUSDT: state.SOLUSDT.LONG,
        ADAUSDT: state.ADAUSDT.LONG,
        DOGEUSDT: state.DOGEUSDT.LONG,
        BNBUSDT: state.BNBUSDT.LONG,
      };
    },
    GT_SHORT_BUY_CONFIGS: (state) => {
      return {
        BTCUSDT: state.BTCUSDT.SHORT,
        ETHUSDT: state.ETHUSDT.SHORT,
        XRPUSDT: state.XRPUSDT.SHORT,
        SOLUSDT: state.SOLUSDT.SHORT,
        ADAUSDT: state.ADAUSDT.SHORT,
        DOGEUSDT: state.DOGEUSDT.SHORT,
        BNBUSDT: state.BNBUSDT.SHORT,
      };
    },
  },
  mutations: {
    /**
     * 매수 설정 및 매수 설정 리스트 state 업데이트
     * @param {*} state
     * @param {*} param1
     */
    MU_UPDATE_SAVE_RESULT: (state, { cv, civ, civList }) => {
      const { symbol, positionSide, ...etc } = cv;
      state[symbol][positionSide].config = { ...etc };
      if (civ != null && civList.length === 0) {
        state[symbol][positionSide].list = [{ ...civ }];
      } else if (civ == null && civList.length !== 0) {
        state[symbol][positionSide].list = civList;
      }
    },
    /**
     * 사용자 입력 매수 설정 config 업데이트
     * @param {*} state
     * @param {*} param1
     */
    MU_UPDATE_SAVE_CV: (state, { cv }) => {
      const { symbol, positionSide, ...etc } = cv;
      state[symbol][positionSide].config = { ...etc };
    },
    /**
     * 매수 설정 및 매수 설정 리스트 일괄 state 업데이트
     * @param {*} state
     * @param {*} payload
     */
    MU_UPDATE_GET_ALL_RESULT: (state, payload) => {
      for (let i = 0; i < payload.length; i++) {
        const { tradeConfig, itemList, tpItem, slItem } = payload[i];
        if (tradeConfig == null) continue;
        const { symbol, positionSide, ...etc } = tradeConfig;
        state[symbol][positionSide].config = { ...etc };
        state[symbol][positionSide].list = [...itemList];
        state[symbol][positionSide].profit = tpItem;
        state[symbol][positionSide].force = slItem;
      }
    },
    /**
     * 매수 설정 및 매수 리스트 단일건 state 업데이트
     * @param {*} state
     * @param {*} payload
     */
    MU_UPDATE_GET_RESULT: (state, payload) => {
      const { tradeConfig, itemList, tpItem, slItem } = payload;
      if (tradeConfig != null) {
        const { symbol, positionSide, ...etc } = tradeConfig;
        state[symbol][positionSide].config = { ...etc };
        state[symbol][positionSide].list = [...itemList];
        state[symbol][positionSide].profit = tpItem;
        state[symbol][positionSide].force = slItem;
      }
    },
    MU_EMPTY: () => {
      console.log("done");
    },
  },
  actions: {
    /**
     * 매수 설정 저장
     * @param {Mutations} param0
     * @param {BuyConfigSave} payload
     * @returns
     * flag: boolean (성공 여부)
     * msg : string (에러 메시지)
     */
    AC_SAVE_BUY_CONFIG: async ({ commit }, payload) => {
      const resultObject = {
        flag: false,
        msg: "",
      };

      const endpoint = `${apiPrefix}/buy/config/${payload.symbol}/${payload.positionSide}`;

      const apiResponse = await authFetch.post(endpoint, payload);

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        // success

        // resultSet parsing
        // cv : 매수 설정 데이터
        // civ : 매수 설정 거래 데이터
        // apiResult : 포지션 진입 바이낸스 요청 결과

        const { cv } = apiResponse.data;

        commit("MU_UPDATE_SAVE_CV", { cv: cv });

        // 수동 매수,중지 버튼 업데이트

        resultObject.flag = true;
      } else {
        // error
        console.log(apiResponse.status);
        resultObject.flag = false;
        resultObject.msg = "ERROR";
      }

      return resultObject;
    },

    /**
     * 매수 설정 수정
     * @param {*} param0
     * @param {*} payload
     */
    AC_UPDATE_BUY_CONFIG: async ({ commit }, payload) => {
      const endpoint = `${apiPrefix}/buy/config/${payload.tradeConfigId}`;

      const apiResponse = await authFetch.patch(endpoint, payload);

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        const { cv, civList } = apiResponse.data;
        commit("MU_UPDATE_SAVE_RESULT", {
          cv: cv,
          civ: null,
          civList: civList,
        });
        alert("성공적으로 수정되었습니다.");
      } else {
        // error
        alert("수정중 오류가 발생했습니다.");
      }
    },

    /**
     * 매수 설정 실행
     * @param {*} param0
     * @param {*} payload
     */
    AC_EXEC_BUY_CONFIG: async ({ commit }, payload) => {
      const endpoint = `${apiPrefix}/buy/config/trade/${payload.symbol}/${payload.position}/${payload.tradeConfigId}`;

      const apiResponse = await authFetch.post(endpoint);

      let result = "SUCCESS";
      let updateResultType = "tradeConfig";
      if (apiResponse.status === 200 || apiResponse.status === 201) {
        const { cv, civ, apiResult, updateType } = apiResponse.data;
        updateResultType = updateType;
        if (apiResult === "SUCCESS") {
          alert("성공적으로 요청되었습니다.");
          commit("MU_UPDATE_SAVE_RESULT", { cv, civ, civList: [] });
          updateResultType = updateType;
        } else {
          if (!apiResult) {
            console.log("start...");
          } else {
            alert(
              "포지션 진입에 실패했습니다. 매수 설정 값을 확인해주시기 바랍니다."
            );
          }

          commit("MU_UPDATE_SAVE_RESULT", { cv, civ, civList: [] });
          result = "ERROR";
        }
      } else {
        if (apiResponse.status === 400) {
          alert("요청 데이터가 올바르지 않습니다.");
        } else {
          alert("실행도중 오류가 발생했습니다.");
        }
        result = "ERROR";
      }

      return { result, updateResultType };
    },
    AC_EXEC_BUY_STOP: async ({ commit }, payload) => {
      const endpoint = `${apiPrefix}/buy/config/stop/${payload.symbol}/${payload.position}/${payload.tradeConfigId}`;

      const apiResponse = await authFetch.post(endpoint);

      let result = null;

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        const { isBuyStop, cv } = apiResponse.data;

        commit("MU_UPDATE_SAVE_CV", { cv: cv });

        result = isBuyStop;
      } else {
        if (apiResponse.status === 400) {
          alert("요청 데이터가 올바르지 않습니다.");
        } else {
          alert("실행도중 오류가 발생했습니다.");
        }
      }
      return result;
    },

    /**
     * 매수 설정 불러오기 (전체 조회)
     * @param {Mutations} param0
     */
    AC_GET_ALL_CONFIGS: async ({ commit }) => {
      const endpoint = `${apiPrefix}/buy/config/all`;

      const apiResponse = await authFetch.get(endpoint);

      if (apiResponse.status === 200) {
        commit("MU_UPDATE_GET_ALL_RESULT", apiResponse.data);
      } else {
        //error
        console.log("ac get all configs --- error");
      }
    },
    /**
     * 매수 설정 불러오기 (특정 코인, 특정 포지션)
     * @param {*} param0
     * @param {*} param1
     */
    AC_GET_CONFIG: async ({ commit }, { symbol, position }) => {
      const endpoint = `${apiPrefix}/buy/config/${symbol.toUpperCase()}/${position.toUpperCase()}`;

      const apiResponse = await authFetch.get(endpoint);

      if (apiResponse.status == 200) {
        commit("MU_UPDATE_GET_RESULT", apiResponse.data);
      } else {
        console.log("ac get config --- error");
      }
    },

    AC_MODIFY_TPSL: async (
      { dispatch },
      { tradeConfigId, tradeItemId, body }
    ) => {
      const endpoint = `${apiPrefix}/buy/config/tpsl/${tradeConfigId}/${tradeItemId}`;

      const apiResponse = await authFetch.patch(endpoint, body);

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        const { flag, msg, apiFlag, apiMsg } = apiResponse.data;
        if (flag) {
          // 수정 성공
          if (apiFlag) {
            alert("성공적으로 요청되었습니다.");
          } else {
            switch (apiMsg) {
              case "ORDER_IMMEDIATELY_TRIGGER":
                alert(
                  "트리거 조건에 부합하지 않습니다. 변경 값을 조정후 다시 시도해주시기 바랍니다."
                );
                break;
            }
          }
          await dispatch("AC_GET_ALL_CONFIGS");
        } else {
          switch (msg) {
            case "NO_TI":
            case "NO_TC":
              alert(
                "일치하는 매수주문이 없습니다. 새로고침후 다시 시도해주시기 바랍니다."
              );
              break;
            case "NO_SC":
              alert(
                "바이낸스의 심볼 정보가 존재하지 않습니다. 새로고침 후 다시 시도해주시기 바랍니다."
              );
              break;
            case "NO_BUY_SELL":
              alert(
                "올바르지 않은 정보입니다. 새로고침 후 다시 시도해주시기 바랍니다."
              );
              break;
            case "INVALID_CONDITION":
              alert(
                "올바르지 않은 거래 타입입니다. 새로고침 후 다시 시도해주시기 바랍니다."
              );
              break;
          }
          // 수정 실패
        }
      } else if (apiResponse.status == 400) {
        alert("입력값을 확인해주시기 바랍니다.");
      } else {
        alert(
          "변경중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다."
        );
      }
    },

    AT_TRADE_DELAY_FORCE: async ({ commit }, payload) => {
      const url = `${apiPrefix}/buy/delay/trade/${payload}`;

      const apiResponse = await authFetch.post(url);

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        // flag , msg , data
        const { flag, msg, data } = apiResponse.data;

        if (flag) {
          // true => 처리완료
          // TODO : 해당 매수 설정 및 매수 아이템 업데이트 필요
          commit("MU_EMPTY");
          console.log(data != null);
        } else {
          // false => 에러

          if (msg === "ALREADY") {
            alert("이미 처리되었습니다.");
          } else {
            alert("강제 재진입 중 오류가 발생했습니다.");
          }
        }
      } else {
        alert("처리중 오류가 발생했습니다.");
      }
    },
  },
};
